(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["albrecht-shopping-tools"] && !Shopify.designMode) return;
  try {
    
function initAlbrechtTools(scope=document){
  scope.querySelectorAll('[data-az-tools]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    if(location.hash==='#albrecht-compare'){const panel=root.querySelector('.az-comparison');if(panel)panel.open=true;}
    root.querySelector('[data-size-form]').addEventListener('submit',event=>{
      event.preventDefault();
      const input=event.currentTarget.querySelector('input');
      const value=input.value.trim().toUpperCase();
      const match=value.match(/^(?:\d{3}\s*\/\s*\d{2}\s*)?(?:ZR|R)\s*(\d{2})(?:\s+\d{2,3}[A-Z])?$/)||value.match(/^(\d{2})(?:\s*ZOLL)?$/);
      const result=root.querySelector('[data-size-result]'),link=root.querySelector('[data-size-link]');
      link.hidden=true;
      if(!match){result.textContent=root.dataset.invalid;input.setAttribute('aria-invalid','true');return;}
      input.removeAttribute('aria-invalid');
      const size=Number(match[1]);
      if(size<13||size>17){result.textContent=root.dataset.outside;return;}
      result.textContent=root.dataset.result.replace('{size}',String(size));
      const destination=root.querySelector('.az-size-links a[href$="/'+size+'-zoll"]');
      link.href=destination.href;link.hidden=false;
    });
    root.querySelectorAll('[data-model]').forEach((select,index)=>{
      select.addEventListener('change',()=>{
        const slot=select.closest('.az-compare-slot').querySelector('[data-model-result]');
        slot.replaceChildren();
        const template=Array.from(root.querySelectorAll('template[data-model-template]')).find(t=>t.dataset.modelTemplate===select.value);
        if(!template)return;
        slot.append(template.content.cloneNode(true));
        const variants=slot.querySelector('[data-variant]');
        variants.id+='-'+index;slot.querySelector('label').htmlFor=variants.id;
        const update=()=>{
          const variant=variants.selectedOptions[0];
          slot.querySelector('dd[data-price]').textContent=variant.dataset.price;
          slot.querySelector('[data-availability]').textContent=variant.dataset.available==='true'?root.dataset.available:root.dataset.unavailable;
          slot.querySelector('[data-product-link]').href=variant.dataset.url;
        };
        variants.addEventListener('change',update);update();
      });
    });
  });
}
initAlbrechtTools();
document.addEventListener('shopify:section:load',event=>initAlbrechtTools(event.target));

  } catch(e) { console.error(e); }
})();
})();
